import { HEADER_CHECKOUT_CONST } from './HeaderCheckout.d';
import { HeaderCheckout } from './HeaderCheckout.styles';
import type { HeaderCheckoutProps } from './HeaderCheckout.d';

const HeaderCheckoutBase = ({ children }: HeaderCheckoutProps) => (
  <HeaderCheckout.Header data-header-checkout={true} fixed={false}>
    <HeaderCheckout.Component data-testid={HEADER_CHECKOUT_CONST.TEST_ID}>
      {children}
    </HeaderCheckout.Component>
  </HeaderCheckout.Header>
);

export default HeaderCheckoutBase;
